import type { SVGProps } from "react";
export interface PanHotIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function PanHotIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: PanHotIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M21.039 5.643a1.126 1.126 0 0 1 1.434.464l.5.867a1.125 1.125 0 0 1-.412 1.537l-2.6 1.5a1.12 1.12 0 0 1-1.054.036l-3.53 2.04a1.125 1.125 0 0 1-1.125-1.95L17.778 8.1a1.12 1.12 0 0 1 .56-.906l2.598-1.5zM4.164 1.926a1.125 1.125 0 0 1 .78 2.107l-.033.014c.008-.003-.006 0-.02.037a.17.17 0 0 0 0 .122l.3.736c.441 1.078.047 2.384-.995 2.97l-.217.107-.035.014-.107.041a1.125 1.125 0 0 1-.78-2.108l.033-.014.02-.035a.17.17 0 0 0-.001-.124l-.3-.736c-.47-1.15.01-2.559 1.212-3.077l.034-.013zm4.5 0a1.125 1.125 0 0 1 .78 2.107l-.033.014c.008-.003-.006 0-.02.037a.17.17 0 0 0 0 .122l.3.736.079.219c.308 1.03-.101 2.204-1.074 2.75l-.217.108-.035.014-.107.041a1.125 1.125 0 0 1-.78-2.108l.033-.014.02-.035a.2.2 0 0 0 .01-.062l-.011-.062-.3-.736c-.47-1.15.01-2.559 1.212-3.077l.034-.013zm4.5 0a1.125 1.125 0 0 1 .78 2.107l-.033.014c.008-.003-.006 0-.02.037a.17.17 0 0 0 0 .122l.3.736.079.219c.308 1.03-.101 2.204-1.074 2.75l-.217.108-.035.014-.107.041a1.125 1.125 0 0 1-.78-2.108l.033-.014.02-.035a.2.2 0 0 0 .01-.062l-.011-.062-.3-.736c-.47-1.15.01-2.559 1.213-3.077l.033-.013z"
      />
      <path
        fill={color}
        d="M2.875 19.5a1.125 1.125 0 0 1 2.25 0v.375h2.25V19.5a1.125 1.125 0 0 1 2.25 0v.375h2.25V19.5a1.125 1.125 0 0 1 2.25 0v.375H15l.114.006a1.126 1.126 0 0 1 0 2.239l-.114.005H2a1.125 1.125 0 0 1 0-2.25h.875zm11-7.375H3.126v.874c0 1.036.84 1.875 1.875 1.875h7c1.036 0 1.876-.84 1.876-1.875v-.874Zm2.25.874a4.125 4.125 0 0 1-4.124 4.126H5a4.125 4.125 0 0 1-4.125-4.126v-1.5c0-.897.727-1.624 1.625-1.624h12c.897 0 1.625.727 1.625 1.624z"
      />
    </svg>
  );
}
